export default {
      id: "pattern-plus-right-2-usage",
      viewBox: "0 0 92 93",
      url: "../icon/" + "icons.svg#pattern-plus-right-2-usage",
      toString: function () {
        return this.url;
      }
    }